import React, { useState, useEffect } from "react";
import Login from "../components/Login";
import Register from "../components/Register";

interface Props {
  action: string;
}

const LoginOrRegister: React.FC<Props> = ({ action }) => {
  return (
    <div className="container-fluid vh-100">
      <div className="row vh-100">
        {/* Colonne gauche : Form */}
        <div className="col-md-6 d-flex flex-column justify-content-center align-items-center bg-light p-5">
          <div className="text-center mb-4">
            <img
              src="/logos/logo_vivanoda_ai.svg"
              alt="Logo"
              height="50"
              className="mb-2"
            />
            <h4 className="fw-bold">Welcome to TravelAI</h4>
            <p className="text-muted">Log in or create your account</p>
          </div>

          <div className="w-100" style={{ maxWidth: "400px" }}>
            {action === "login" && <Login />}
            {action === "register" && <Register />}
            <div className="w-100 text-center text-muted">contact@vivanoda.com</div>
          </div>
        </div>

        {/* Colonne droite : Cover image */}
        <div className="col-md-6 d-none d-md-block p-0">
          <div
            className="login-cover h-100 w-100"
            style={{ backgroundImage: "url('/images/lisboa.jpg')" }}
          />
        </div>
      </div>
    </div>
  );
};

export default LoginOrRegister;
